import { render, staticRenderFns } from "./createRoleDialog.vue?vue&type=template&id=3618effa&scoped=true"
import script from "./createRoleDialog.vue?vue&type=script&lang=js"
export * from "./createRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./createRoleDialog.vue?vue&type=style&index=0&id=3618effa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618effa",
  null
  
)

export default component.exports